export default __webpack_public_path__ + "static/media/243.44e30d9a.png";